import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  Drawer,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createPaymentMethod,
  deletePaymentMethod,
  getPaymentMethods,
  updatePaymentMethod,
} from "../../../../redux/reducers/paymentMethodSlice";
import { AppColors } from "../../../../util/AppColors";

import CustomButton from "../../../../components/CustomButton";
import CustomModal from "../../../../components/CustomModal/CustomModal";
function PaymentMethod() {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [form, setForm] = useState({ name: "", status: true });
  const [delModVisible, setDelModVisible] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);

  const paymentState = useSelector((state) => state.paymentMethod);
  const rows = paymentState.list;

  useEffect(() => {
    dispatch(getPaymentMethods());
  }, [dispatch]);

  // const normalizePaymentMethod = (value) => {
  //   const lower = value.toLowerCase();
  //   if (lower === 'card') return 'Card';
  //   if (lower === 'cash') return 'Cash';
  //   if (lower === 'upi') return 'UPI'; // Force exact match for UPI
  //   return null; // Invalid method
  // };

  const handleAddOrUpdate = () => {
    if (!form.name.trim()) {
      alert("Please enter a payment method name.");
      return;
    }
    const userInput = form.name.trim();

    if (!userInput || userInput.length === 0) return;

    // const normalizedValue = normalizePaymentMethod(userInput);

    // if (!normalizedValue) {
    //   alert('Invalid Payment Method. Please enter one of: Card, Cash, UPI');
    //   return;
    // }

    if (editIndex !== null) {
      const method = rows[editIndex];
      dispatch(
        updatePaymentMethod({
          methodId: method.methodId,
          name: userInput,
          status: form.status,
        })
      );
    } else {
      dispatch(createPaymentMethod({ name: form.name, status: form.status }));
    }

    handleDrawerClose();
  };
  const handleEdit = (index) => {
    const method = rows[index];
    setForm({ name: method.name || "", status: method.status });
    setEditIndex(index);
    setOpenDrawer(true);
  };

  const handleDrawerClose = () => {
    setOpenDrawer(false);
    setForm({ name: "", status: true });
    setEditIndex(null);
  };

  const handleDeleteClick = (index) => {
    setDeleteIndex(index);
    setDelModVisible(true);
  };

  const handleDelConfirm = () => {
    const method = rows[deleteIndex];
    dispatch(deletePaymentMethod({ methodId: method.methodId }));
    setDelModVisible(false);
    setDeleteIndex(null);
  };

  const handleDelModClose = () => {
    setDelModVisible(false);
    setDeleteIndex(null);
  };

  const filteredRows = rows.filter((row) =>
    (row.name || "").toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Box p={3}>
      {/* Top Section */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
        flexWrap="wrap"
      >
        <Box display="flex" gap={2} mx="auto" mb={2}>
          <TextField
            label="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            variant="outlined"
            size="small"
            sx={{ width: "500px", backgroundColor: AppColors.lightPink }}
          />
          <Button variant="contained" onClick={() => setOpenDrawer(true)}>
            Create
          </Button>
        </Box>
        <Typography variant="h6" sx={{ ml: "auto" }}>
          Total Payment Methods: {filteredRows.length}
        </Typography>
      </Box>

      {/* Table */}
      <Box sx={{ mt: 2, height: "60vh" }}>
        <TableContainer component={Paper} sx={{ mt: 2, maxHeight: 400 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>S.No</TableCell>
                {/* <TableCell>Method ID</TableCell> */}
                <TableCell>Payment Method</TableCell>
                <TableCell>Status</TableCell>
                {/* <TableCell>Created By</TableCell> */}
                <TableCell>User Name</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody sx={{ overflowY: "auto" }}>
              {filteredRows.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    No records found
                  </TableCell>
                </TableRow>
              ) : (
                filteredRows.map((row, index) => (
                  <TableRow key={row.methodId}>
                    <TableCell>{index + 1}</TableCell>
                    {/* <TableCell>{row.methodId}</TableCell> */}
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.status ? "Active" : "Inactive"}</TableCell>
                    {/* <TableCell>{row.createdBy || '-'}</TableCell> */}
                    <TableCell>{row.userName || "-"}</TableCell>
                    <TableCell>
                      {row.createdDate
                        ? new Date(row.createdDate).toLocaleDateString()
                        : "-"}
                    </TableCell>
                    <TableCell>
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={() => handleEdit(index)}
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        color="error"
                        size="small"
                        onClick={() => handleDeleteClick(index)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* Drawer for Create/Edit */}
      <Drawer anchor="right" open={openDrawer} onClose={handleDrawerClose}>
        <Box p={3} width={300}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h6" color="primary">
              {editIndex !== null
                ? "Edit Payment Method"
                : "Create Payment Method"}
            </Typography>
            <IconButton onClick={handleDrawerClose} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
          <TextField
            fullWidth
            label="Payment Method"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            margin="normal"
            InputLabelProps={{
              sx: {
                position: "absolute",
                top: "50%",
                left: "14px",
                transform: "translateY(-50%)",
                transition: "all 0.2s ease-out",
                "&.Mui-focused, &.MuiFormLabel-filled": {
                  top: "0px",
                  transform: "translateY(-50%) scale(0.75)",
                  transformOrigin: "top left",
                },
              },
            }}
          />
          <TextField
            fullWidth
            select
            label="Status"
            value={form.status ? "true" : "false"}
            onChange={(e) =>
              setForm({ ...form, status: e.target.value === "true" })
            }
            margin="normal"
            SelectProps={{ native: true }}
          >
            <option value="true">Active</option>
            <option value="false">Inactive</option>
          </TextField>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
            onClick={handleAddOrUpdate}
          >
            {editIndex !== null ? "Update" : "Add"}
          </Button>
        </Box>
      </Drawer>

      {/* Delete Confirmation Modal */}
      <CustomModal
        open={delModVisible}
        onClose={handleDelModClose}
        header="Delete"
        modal
        modalWidth={30}
      >
        <Typography className="flex-center txt-regular fs14">
          Are you sure you want to delete this record?
        </Typography>
        <div className="flex-center mb10 mt15">
          <div>
            <CustomButton text="Cancel" onClick={handleDelModClose} />
          </div>
          <div className="ml10">
            <CustomButton redBtn text="Confirm" onClick={handleDelConfirm} />
          </div>
        </div>
      </CustomModal>
    </Box>
  );
}

export default PaymentMethod;
